import { useState, useEffect } from 'react';
import { useTranslation } from '../context/TranslationContext';
import { API_BASE_URL } from '../services/api';
import './HolidayBanner.css';

function formatDate(date, langCode) {
  const locale = langCode === 'de' ? 'de-CH' : 'en-CH';
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

export default function HolidayBanner() {
  const [holiday, setHoliday] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const { t, langCode } = useTranslation();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/holidays/current`);
        if (res.ok) {
          const data = await res.json();
          if (!cancelled) setHoliday(data);
        }
      } catch {
        // Silently fail
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!holiday || dismissed) return null;

  const endDate = new Date(holiday.end_date);
  const message = holiday.message ||
    t('holidayDefaultMessage', '', {
      returnDate: formatDate(new Date(endDate.getTime() + 86400000), langCode)
    });

  return (
    <div className="holiday-banner" role="alert" aria-live="polite">
      <div className="holiday-banner-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="holiday-banner-icon">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span>{message}</span>
        <button
          className="holiday-banner-close"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>
    </div>
  );
}
